<p-dialog modal="true" styleClass="atlas-dialog-s" position="top" [closable]="false" [(visible)]="show">
  <ng-template pTemplate="header">{{ 'tasks.generate.generate-tasks' | translate | uppercase }} </ng-template>

  <form #generateForm="ngForm">
    <div
      class="atlas-form mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-start mct-items-center mct-gap-27"
    >
      <div class="mct-flex mct-col mct-flex-1-1-0">
        <label>{{ 'tasks.generate.project-type' | translate | titlecase }}</label>
        <p-select
          appendTo="body"
          [options]="projectTypeOptions"
          [(ngModel)]="selectedProjectId"
          [placeholder]="'common.select-dashes' | translate | titlecase"
          required
          name="projectType"
        ></p-select>
      </div>
      <div class="mct-flex mct-col">
        <label> {{ 'tasks.generate.start-date' | translate | titlecase }}</label>
        <wl-date-selector ngDefaultControl name="startDate" appendTo="body" [(ngModel)]="startDate" [required]="true"></wl-date-selector>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" class="atlas-btn atlas-btn-secondary mr-10" [disabled]="isSaving" (click)="show = false">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button type="button" class="atlas-btn atlas-btn-primary" [disabled]="!generateForm.valid" (click)="generate()">
      <wl-busy [show]="isSaving"></wl-busy>
      <span [hidden]="isSaving">{{ 'tasks.generate.generate-tasks' | translate | uppercase }}</span>
    </button>
  </ng-template>
</p-dialog>
